import { ButtonPrimary } from 'front-end/src/components'
import React, { useState } from 'react'
import { t, Trans } from '@lingui/macro'
import CommentHeader from '../comment-header/CommentHeader'
import { ICommentIdentifier } from '../comments-footer/CommentsFooter'
import {
  useAddCommentOnEventMutation,
  useAddCommentOnTopicMutation,
  useAddCommentOnPathwayMutation
} from './AddComment.codegen'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

const mutations = {
  event: useAddCommentOnEventMutation,
  topic: useAddCommentOnTopicMutation,
  pathway: useAddCommentOnPathwayMutation
}

export const AddComment: React.FC<
  ICommentIdentifier & {
    onCreated: () => void
  }
> = (props) => {
  const [content, setContent] = useState('')
  const { session } = usePublicApiSession()
  const [addComment] = mutations[props.itemType]()

  return (
    <div className="comments-new-comment">
      <div className="comment">
        {session?.user && <CommentHeader author={session?.user} />}
        <div className="comment-edit">
          <textarea
            name="content"
            title="content"
            placeholder={t`Continue the conversation`}
            value={content}
            onChange={(ev) => {
              setContent(ev.target.value)
            }}
          />

          <ButtonPrimary
            disabled={content.length === 0}
            onClick={async () => {
              await addComment({
                variables: {
                  id: props.itemId,
                  content
                }
              })
              setContent('')
              props.onCreated()
            }}
          >
            <Trans>Add</Trans>
          </ButtonPrimary>
        </div>
      </div>
    </div>
  )
}
